import { ContentWrapper } from './components/ContentWrapper';
import { NavigationItemIcon } from './components/NavigationItemIcon';
import { NavigationItemText } from './components/NavigationItemText';

import type {
  SidebarAnimatedComponentsState,
  NavigationItemState,
  NavigationItem,
} from 'layout/MainLayout/components/Sidebar/types';
import type { FC } from 'react';

type NavigationItemContentProps = SidebarAnimatedComponentsState &
  NavigationItemState &
  Omit<NavigationItem, 'to'>;

export const NAVIGATION_ITEM_CONTENT_TEST_ID = 'navigation-item-content';

export const NavigationItemContent: FC<NavigationItemContentProps> = ({
  sidebarType,
  label,
  icon,
  isActive,
  opened,
  disabled,
}) => (
  <ContentWrapper data-testid={NAVIGATION_ITEM_CONTENT_TEST_ID}>
    {icon && (
      <NavigationItemIcon
        sidebarType={sidebarType}
        opened={opened}
        isActive={isActive}
        disabled={disabled}
      >
        {icon}
      </NavigationItemIcon>
    )}
    <NavigationItemText
      disableTypography
      isActive={isActive}
      primary={label}
      disabled={disabled}
      sidebarType={sidebarType}
    />
  </ContentWrapper>
);
